var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 40C7.5 22.0507 22.0507 7.5 40 7.5C57.9493 7.5 72.5 22.0507 72.5 40C72.5 57.9493 57.9493 72.5 40 72.5C22.0507 72.5 7.5 57.9493 7.5 40ZM52.0343 33.9531C52.8369 32.8296 52.5766 31.2682 51.4531 30.4657C50.3296 29.6631 48.7682 29.9234 47.9657 31.0469L37.181 46.1455L31.7678 40.7322C30.7915 39.7559 29.2085 39.7559 28.2322 40.7322C27.2559 41.7085 27.2559 43.2915 28.2322 44.2678L35.7322 51.7678C36.2519 52.2874 36.9738 52.5521 37.7062 52.4915C38.4386 52.4309 39.1072 52.0511 39.5343 51.4531L52.0343 33.9531Z",
    fill: "#1B9964"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.a50580a9e431310c44801dd1df3abc47.svg";
export { ForwardRef as ReactComponent };